import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import {
	EventContext,
	OfferOptionsContext,
	OfferStoreContext,
} from "@gp/components";
import { useIsAdditionalOfferVisible } from "@utils/offer";
import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useContext } from "react";

export default observer(function BettingTypeGroupHeaderInfo(props: {
	isExpanded?: boolean;
	onSetExpand: (newValue: boolean) => void;
	group: { abrv: string; name: string };
	isFavorite?: boolean;
	isBetBuilder?: boolean;
}) {
	const { isExpanded, onSetExpand, group, isFavorite } = props;
	const favoritesStore = useContext(FavoritesStoreContext);

	const event = useContext(EventContext);
	const store = useContext(OfferStoreContext);
	const options = useContext(OfferOptionsContext);

	const isAdditionalOfferVisible = useIsAdditionalOfferVisible();
	const eventKeys = store.eventKeysMap.get(event.id);

	if (eventKeys == null || eventKeys.size === 0) {
		return null;
	}

	let count;
	if (isFavorite) {
		count = Array.from(eventKeys.values()).reduce((acc, key) => {
			if (key.bettingType.groupId !== group.abrv) {
				return (acc += 0);
			}
			if (
				!favoritesStore.isUserFavoriteBettingType(
					key.bettingTypeId,
					key.specifier || null
				)
			) {
				return (acc += 0);
			}
			return (acc += 1);
		}, 0);
	} else if (props.isBetBuilder) {
		count = Array.from(eventKeys.values()).reduce(
			(acc, key) =>
				(acc +=
					key.bettingType.groupId === group.abrv && key.betBuilder
						? 1
						: 0),
			0
		);
	} else if (
		//@ts-expect-error
		options.shouldDisplayShowMore &&
		//@ts-expect-error
		store.displayBettingGroup == "all" &&
		//@ts-expect-error
		!store.isExpanded &&
		//@ts-expect-error
		store.defaultBettingTypeDisplay.length
	) {
		count = Array.from(eventKeys.values()).reduce(
			(acc, key) =>
				(acc +=
					key.bettingType.groupId === group.abrv &&
					//@ts-expect-error
					key.bettingType.isDefaultBettingType
						? 1
						: 0),
			0
		);
	} else {
		count = Array.from(eventKeys.values()).reduce(
			(acc, key) =>
				(acc += key.bettingType.groupId === group.abrv ? 1 : 0),
			0
		);
	}

	const headClass = classNames(
		"offer__head offer__head--secondary offer--additional__head",
		{
			"is-collapsed": !isExpanded,
			"is-expanded": isExpanded,
		}
	);

	const iconClass = classNames("offer__toggle__icon u-icon u-icon--tny", {
		"u-icon--caret--down": isExpanded,
		"u-icon--caret--right": !isExpanded,
	});

	const toggleClasses = classNames("offer__head__data offer__toggle", {
		"offer__toggle--sml": isAdditionalOfferVisible,
	});

	return (
		<div className={headClass}>
			<div className="offer__head__row offer--additional__head__row">
				<div
					className="offer__head__data offer__title"
					title={group.name}
				>
					<div className="offer__title__wrapper">
						<span className="offer__name offer--additional__group">
							{group.name}
						</span>
						<span className="counter counter--base counter--dark--outlined">
							{count}
						</span>
					</div>
				</div>
				<div className={toggleClasses}>
					<button
						className="offer__toggle__btn btn btn--square btn--square--xsml btn--ghost"
						type="button"
						onClick={() => onSetExpand(!isExpanded)}
					>
						<i className={iconClass} />
					</button>
				</div>
			</div>
		</div>
	);
});
